exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-label[data-v-56299096] {\n  font-weight: bold;\n  margin-bottom: 0;\n}\n", ""]);

// exports
